<button type="button" class="switch" role="switch"
    [class.active]="isActive"
    [class.inactive]="!isActive"
    [class.disabled]="disabled"
    [attr.aria-checked]="isActive"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-disabled]="disabled || null"
    (click)="toggleSwitch()">
    <span class="switch__knob" aria-hidden="true"></span>
    <span class="switch__label">{{ label }}</span>
</button>
